module.exports = __webpack_public_path__ + "6c4a0dbc/img/grid-web-icon.d0395d64.svg";